import { getToken } from '../../utils/auth';
import { getAuthTokenAsync } from '../../utils/authToken';
import { checkStatus, handleError } from '../../utils/api';
import { AffiliationSearch } from '../../interfaces/register';
import apiFetch from '../core/apiFetch';

interface Affiliations {
  affiliations: AffiliationSearch[];
}

const mapAffiliations = (affiliationRankings): AffiliationSearch[] =>
  affiliationRankings.map((ar) => ({
    label: ar.display_name,
    value: ar.affiliation_name,
    id: ar.affiliation_id,
    type: ar.affiliation_type,
  }));

const getAffiliationRankingsAsync = async (
  stateId: number
): Promise<Affiliations> => {
  // Guest coverage-check flow has no user token; fall back to the app token.
  const token = getToken() || (await getAuthTokenAsync());
  const url = `api/v1/affiliation_rankings?state_id=${stateId}`;

  try {
    const response = await apiFetch(token, url, { method: 'GET' });
    await checkStatus(response);

    const { affiliation_rankings: affiliationRankings } = await response.json();

    return { affiliations: mapAffiliations(affiliationRankings) };
  } catch (error) {
    handleError('unexpected status - get affiliation rankings', error);
    return { affiliations: [] };
  }
};

export default getAffiliationRankingsAsync;
